const defaultTexts = {
	dropDownPlaceholder: 'Bitte wählen Sie eine Option aus.',
	checkoutHintText: `<div style="display:inline-flex; word-break:keep-all;">
		Mit dem Klick auf "Kaufen und bezahlen" bestellen Sie verbindlich die Karten und starten den Bezahlvorgang.</br> 
		Sie erhalten sofort eine Bestellbestätigung.</div>`,
	checkoutHintPopupTitle: 'Wie läuft der Kaufvorgang ab?',
	checkoutHintPopupText: `<p>Sie haben oben bereits die Zahlungsart und die Versandart ausgewählt. 
		Mit dem Klick auf "Kaufen und bezahlen" bestellen Sie verbindlich und kostenpflichtig zum angezeigten Preis.</p></br> 
		<p>Sie erhalten sofort eine Bestellbestätigung per E-Mail.</p></br> <p>Unabhängig von dieser E-Mail müssen Sie zunächst noch bezahlen. 
		Erst mit einer erfolgreichen Bezahlung ist die Bestellung abgeschlossen und Sie erhalten Ihre Karten.</p></br> 
		<p>Wenn Sie mit Überweisung bezahlen, stehen dort Informationen zur Kontoverbindung und der Überweisung.</p></br> 
		<p>Bei elektronischen Zahlungswegen, wie PayPal oder Kreditkarte, 
		werden Sie gegebenenfalls auf die Seite unseres Zahlungsanbieters weitergeleitet. 
		Bitte halten Sie alle benötigten Informationen zu Ihrem Zahlungsmittel bereit.</p></br> 
		<p>Auch wenn die Zahlung abgebrochen wird, gilt die Bestellung als verbindlich.</p></br> 
		Wenden Sie sich in diesem Fall bitte per E-Mail an <a style="color: #9c1324;" href="mailto:support@leoticket.de">support@leoticket.de</a>. 
		Wir helfen Ihnen dann Ihre Bestellung abzuschließen.`,
	purchaseSuccessHeadline2: 'Wir wünschen Ihnen viel Spaß!',
	buttonTextContinueToPayment: 'Weiter zur Zahlung',
	buttonTextBuyNow: 'Jetzt kaufen',
	buttonTextContinueCheckoutNoPayment: 'Weiter zur Anmeldung',
	buttonTextRegisterNow: 'Jetzt anmelden',
	saleNotPossibleInfoNotOnSale: 'Diese Veranstaltung ist zur Zeit nicht für den Verkauf freigegeben.',
	saleNotPossibleInfoCategoriesAreNotAvailable: 'Diese Veranstaltung wird derzeit online nicht verkauft.',
	saleNotPossibleInfoTicketsNotAvailable: 'Diese Veranstaltung ist derzeit online ausverkauft.',
	saleNotPossibleInfoShipmentPaymentNotPossible: 'Diese Veranstaltung ist online nicht mehr buchbar.',
	saleNotPossibleInfoDefault: 'Der Online-Verkauf für diese Veranstaltung ist derzeit nicht verfügbar.',
	waitingQueueSpinnerText: `Sie befinden sich in der Warteschlange und werden gleich zur Online-Buchung weitergeleitet.<br>
		Bitte haben Sie einen Moment Geduld.`,
	webshopOccupiedText: 'Bisher wurde noch keine Sitzung frei. Bitte versuchen Sie es später.',
	accessCodeInfoText: 'Falls Sie über einen Sponsoren- oder Aktionscode verfügen, geben Sie den Code bitte hier ein.',
	accessCodeBtnText: 'Mit der Buchung fortfahren',
	toSeatingplanBookingBtn: 'Saalplanbuchung',
	categorySoldOutText: '<span style="font-weight:bold">ausverkauft</span>',
	categorySoldOutPopupTitle: 'Info',
	categorySoldOutPopupText: `Die Kategorie oder die ganze Veranstaltung ist ausverkauft. Im Ticketshop sind keine Karten mehr verfügbar.<br>
	Möglicherweise gibt es noch Karten an einer Tages-/Abendkasse, bitte klären Sie das direkt mit dem Veranstalter. Uns 
	liegen dazu leider keine Informationen vor.`,
	ticketAddressHeadline: 'Personalisierung',
	ticketAddressErrMsg: 'Bitte korrigieren Sie die Eingaben zur Personalisierung',
	marketingApprovalCheckboxLabel: 'Ja, ich möchte Infos zu Veranstaltungen u. Aktionen erhalten.',
	marketingCampaignPopupTitle: '',
	marketingCampaignPopupText: '',
	checkoutBtnBackLabel: 'Zurück',
	checkoutBtnNextLabel: 'Weiter',
	checkoutBtnResetLabel: 'Abbrechen',
	purchaseOverviewHeadline: 'Zusammenfassung',
	paymentProviderOverviewHeadline: 'Zahlungsart',
	vrpCreditHeadline: 'Zahlung',
	backToSCBtnLabel: 'Zurück zum Warenkorb',
	goToStartPageBtnLabel: 'Zur Startseite',
	goToEventOverviewBtnLabel: 'Zum Programm',
	checkoutErrorPageText: '<div>Leider ist ein Fehler aufgetreten. <br>Bitte versuchen Sie es erneut. <br><br>Falls das Problem weiterhin besteht, kontaktieren Sie uns bitte unter 07152 9259 700 oder<a href="mailto:support@leoticket.de"> support@leoticket.de</a>.</div>',
	notFoundPageText: '<div>Die gewünschte Seite konnte leider nicht gefunden werden.<br><br>Bitte überprüfen Sie die eingegebene Adresse.</div>',
	checkoutSCExpiredText: '<div>Ihre Sitzung ist leider abgelaufen. <br><br> Bitte beginnen Sie den Bestellvorgang erneut.</div>',
	crossSellingCallToActionLabel: 'Jetzt dazu buchen >>',
	ppErrorHeadline: 'Zahlung',
	ppErrorTextCancelled: '<div>Die Zahlung wurde abgebrochen.<br><br>Bitte klicken Sie auf zum Warenkorb und starten den Zahlungsprozess erneut.</div>',
	ppErrorTextRejected: '<div>Die Zahlung wurde abgelehnt.<br><br>Bitte klicken Sie auf zum Warenkorb und starten den Zahlungsprozess erneut.</div>',
	ppErrorTextInternal: '<div>Leider ist ein Fehler aufgetreten. <br>Bitte versuchen Sie es erneut. <br><br>Falls das Problem weiterhin besteht, kontaktieren Sie uns bitte unter 07152 9259 700 oder<a href="mailto:support@leoticket.de"> support@leoticket.de</a>.</div>',
	ppErrorTextInvalid_input: '<div>INVALID INPUT</div>',
	ppErrorTextNot_found: '<div>NOT FOUND</div>',
	ppErrorTextExpired: '<div>Ihre Sitzung ist leider abgelaufen. <br><br> Bitte beginnen Sie den Bestellvorgang erneut.</div>',
	ppErrorText:'<div>Leider ist ein Fehler beim Zahlungsprovider aufgetreten.<br><br>Bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsart.</div>',
	vrpDataProcessedText:'Ihre Zahlung wird verarbeitet...',
	noPaymentNeeded: 'keine Zahlung nötig',
	orderCommentTitle: 'Bemerkung',
	orderCommentPlaceholder: 'Haben Sie Anmerkungen zu Ihrer Bestellung? Diese können Sie hier eingeben...',
	placeholderSalutation: 'Anrede',
	placeholderCustomSalutation: 'Individuelle Anrede',
	placeholderCompanyName: 'Firma',
	placeholderFirstname: 'Vorname',
	placeholderLastname: 'Nachname *',
	placeholderPhoneNumber: 'Telefon für Rückfragen *',
	placeholderEmail: 'Email *',
	placeholderStreet: 'Straße *',
	placeholderHouseNumber: 'Hausnummer *',
	placeholderPostalCode: 'PLZ *',
	placeholderCity: 'Ort *',
	placeholderCountry: 'Land',
	ticketAddressPlaceholderFirstname: 'Vorname *',
	ticketAddressPlaceholderEmail: 'Email',
	termsAndConditionDescription: 'Um den Einkauf abzuschließen, müssen Sie die Allgemeinen Geschäftsbedingungen akzeptieren.',
	continueShoppingBtnLabel: 'Weiter einkaufen',
	seatNotAvailable: 'Dieser Sitz ist nicht verfügbar. Bitte wählen Sie einen farbigen Sitz aus.'
};

export default defaultTexts;
